module.exports = __webpack_public_path__ + "static/4ac186280bbae08fbb073976b8b47a6bc1f2d470c5860ff53dcd1113f4c435ef-6ef4b4989062c9206e23dc426560d41a.png";